import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

export const Route = createFileRoute("/app")({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.loading && !context.auth.user) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
